export const EHROrder_SourceLabelMap = {
    fhir: 'FHIR',
    'manually-in-advisor': 'Manually In Advisor',
};
export const EHROrder_AvailabilityLabelMap = {
    always: 'Always',
    partial: 'Partial'
};
export const EHROrder_DaysOrder = [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
];
export const EHROrder_DaysLabelMap = {
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tues',
    wed: 'Wed',
    thu: 'Thurs',
    fri: 'Fri',
    sat: 'Sat'
};
//# sourceMappingURL=consts.js.map